import React, { useState } from "react";
import PropTypes from "prop-types";
import Highlighter from "react-highlight-words";
import GlobalSearch from "./GlobalSearch";

const SearchResultPage = ({ searchResult = [], topicsCount, inputValue, searchUrl }) => {
    const renderLessons = (lessons) =>
        lessons.map((lesson, index) => (
            <React.Fragment key={JSON.stringify(lesson)}>
                {lesson && (
                    <a className="main__search-lesson" href={lesson.url}>
                        Урок {index}:&nbsp;
                        <Highlighter
                            highlightClassName="main__search-matches"
                            searchWords={[inputValue]}
                            textToHighlight={lesson.name}
                        />
                    </a>
                )}
            </React.Fragment>
        ));

    const renderSearchResult = () =>
        searchResult.map((item) => (
            <div key={JSON.stringify(item)}>
                <div className="main__search-result">
                    <a className="main__search-theme" href={item.topic.url}>
                        <Highlighter
                            highlightClassName="main__search-matches"
                            searchWords={[inputValue]}
                            textToHighlight={item.topic.name}
                        />
                    </a>
                    {renderLessons(item.lessons)}
                    <span className="main__search-topic">{item.course.name}</span>
                </div>
            </div>
        ));

    return (
        <section className="search-wr">
            <GlobalSearch searchUrl={searchUrl} inputValue={inputValue} />
            {searchResult.length !== 0 ? (
                <React.Fragment>
                    <span className="main__search-count">Найдено результатов: {topicsCount}</span>
                    <div className="main__search-results">{renderSearchResult()}</div>
                </React.Fragment>
            ) : (
                <div className="main__search-empty">
                    <span>По вашему запросу ничего не найдено</span>
                    <span>Попробуйте изменить запрос</span>
                </div>
            )}
        </section>
    );
};

SearchResultPage.propTypes = {
    searchRes: PropTypes.array,
    topicsCount: PropTypes.number,
    inputValue: PropTypes.string,
    searchUrl: PropTypes.string,
};

export default SearchResultPage;



// WEBPACK FOOTER //
// ./app/frontend/components/SearchResultPage.js